////////////////
// Analytics //
//////////////

import GameAnalytics from "not-game-analytics"

GameAnalytics.isReporting = false

GameAnalytics.BUILD_VERSION = "v0.21.x"

// // THIS BE MUTINY
// GameAnalytics.GAME_KEY = "015a912f9bdd29dc42291faecb5004a3"
// GameAnalytics.SECRET_KEY = "c9b3499fcd37f9e7249ee76cc9fee81ef73f7846"

// // FEAST OF FOOLS
// GameAnalytics.GAME_KEY = "5db1f8009e0693558c9671ed6df1e080"
// GameAnalytics.SECRET_KEY = "f37173aacf4474ddf951371f881eca67e92a5aa4"

window.addEventListener("error", (error) => {
    GameAnalytics.reportError(error)
})
